import { Component } from '@angular/core';

@Component({
    selector: 'app-social-pinterest',
    templateUrl: './social-pinterest.component.html',
    standalone: false
})
export class SocialPinterestComponent {
}
